import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const PopupContainer = styled.div`
  height: ${() => `${viewSizeCalculator(41.5)}`};
  padding: ${() =>
    `${viewSizeCalculator(1.375)} ${viewSizeCalculator(1)} ${viewSizeCalculator(
      0.9437,
    )}`};
  padding-bottom: ${() => `${viewSizeCalculator(1.3)}`};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: ${() => `${viewSizeCalculator(5.7)}`};
  right: ${() => `${viewSizeCalculator(1.1875)}`};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  // box-shadow: 0 ${() => `${viewSizeCalculator(0.0625)}`}
  //   ${() => `${viewSizeCalculator(0.3125)}`} #3333331a;

  box-shadow:
    0 ${() => `${viewSizeCalculator(0.0625)}`}
      ${() => `${viewSizeCalculator(0.3125)}`} #3333330a,
    /* lighter shadow */ 0 ${() => `${viewSizeCalculator(0.125)}`}
      ${() => `${viewSizeCalculator(0.625)}`} #33333314,
    /* lighter shadow */ 0 ${() => `${viewSizeCalculator(0.25)}`}
      ${() => `${viewSizeCalculator(1.25)}`} #3333331f;
  transform: scaleY(${(props) => (props?.isPopupVisible ? 1 : 0)});
  transform-origin: top;
  opacity: ${(props) => (props.isPopupVisible ? 1 : 0)};
  visibility: ${(props) => (props.isPopupVisible ? "visible" : "hidden")};
  transition:
    transform 0.5s ease,
    opacity 0.5s ease,
    visibility 0.3s ease ${(props) => (props.isOpen ? "0s" : "0.3s")};
`;

export const PopupHeader = styled.div`
  width: ${() => `${viewSizeCalculator(24)}`};
  height: ${() => `${viewSizeCalculator(3.25)}`};
  display: flex;
  justify-content: space-between;
  padding: ${() =>
    `${viewSizeCalculator(0)} ${viewSizeCalculator(0.5)} ${viewSizeCalculator(
      0.75,
    )} ${viewSizeCalculator(0.5)}`};

  border-bottom: ${() => `${viewSizeCalculator(0.0625)} solid #EBEBEB`};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const Title = styled.span`
  font-size: ${() => `${viewSizeCalculator(1.05)}`};
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(1.21)}`};
`;

export const Count = styled.p`
  font-size: ${() => `${viewSizeCalculator(1.25)}`};
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(1.5125)}`};
  color: #ee3224;
`;

export const FeatureContainer = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
  align-items: center;

  svg {
    width: ${() => `${viewSizeCalculator(2.5)}`};
    height: ${() => `${viewSizeCalculator(2.5)}`};
  }
`;

export const SvgContainer = styled.div`
  width: ${() => `${viewSizeCalculator(2.5)}`};
  height: ${() => `${viewSizeCalculator(2.5)}`};
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${() => `${viewSizeCalculator(0.125)} solid #3333331a`};
  border-radius: ${() => `${viewSizeCalculator(1.0419)}`};
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
  /* background-color: ${(props) =>
    props.isPopupVisible ? "#f5f5f5" : "none"}; */

  svg {
    width: ${() => `${viewSizeCalculator(1)}`}; // 16px
    height: ${() => `${viewSizeCalculator(0.9688)}`};
  }
`;

export const PopupBody = styled.div`
  width: ${() => `${viewSizeCalculator(24)}`};
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(1)}`};
  padding-top: ${() => `${viewSizeCalculator(1.5)}`};
  flex: 1;
  /* max-height: ${() => `${viewSizeCalculator(30)}`}; */

  overflow-y: scroll;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 0px; // Width of the vertical scrollbar
    //height: 4px; // Height of the horizontal scrollbar
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1; // Light gray background for the scrollbar track
    border-radius: 4px; // Rounded corners for the track
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d; // Light gray color for the scrollbar thumb
    border-radius: 4px; // Rounded corners for the thumb
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380; // Darker gray color when hovering over the scrollbar thumb
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  // width: ${() => `${viewSizeCalculator(20.5)}`};
  height: ${() => `${viewSizeCalculator(3.25)}`};
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  padding: ${() => `${viewSizeCalculator(0.25)} 0 0 0`};
  align-items: flex-start;

  // svg {
  //   width: ${() => `${viewSizeCalculator(2.5)}`};
  //   height: ${() => `${viewSizeCalculator(2.5)}`};
  //   cursor: pointer;
  // }
`;

export const BookmarkIconContainer = styled.div`
  position: relative;
  width: ${() => `${viewSizeCalculator(1.5)}`};
  height: ${() => `${viewSizeCalculator(1.5)}`};
  cursor: pointer;

  svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    transition: opacity 0.15s ease;
  }

  .filled-svg {
    opacity: 1;
  }

  .unfilled-svg {
    opacity: 0;
  }

  &:hover .filled-svg {
    opacity: 0;
  }

  &:hover .unfilled-svg {
    opacity: 1;
  }
`;

export const CompareIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  margin-right: ${() => `${viewSizeCalculator(0.95)}`};

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
    cursor: pointer;
  }
`;

export const ContentFlex = styled.div`
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
  align-items: flex-start;
  flex: 1;
  min-width: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.25)}`};
  font-weight: 500;
  color: #333333;
  padding: 0 ${() => `${viewSizeCalculator(0.25)}`};
  flex: 1;
  min-width: 0;
  overflow: visible;
  cursor: pointer;
`;

export const ContentTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(1)}`};
  line-height: ${() => `${viewSizeCalculator(1.21)}`};
  margin: 0;
  width: 100%;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.35)}`};
  min-width: 0;
  overflow: visible;
`;

export const ContentTitleText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
`;

export const PartnerLocationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${() => `${viewSizeCalculator(1)}`};
  height: ${() => `${viewSizeCalculator(1)}`};
  min-width: ${() => `${viewSizeCalculator(1)}`};
  min-height: ${() => `${viewSizeCalculator(1)}`};
  overflow: visible;

  svg {
    width: 100%;
    height: 100%;
    display: block;
    overflow: visible;
    flex-shrink: 0;
  }
`;

export const ContentSubTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`};
  line-height: ${() => `${viewSizeCalculator(1)}`};
  opacity: 60%;
  margin: 0;
  text-transform: capitalize;
`;

export const PopupFooter = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ViewAllButtonWrapper = styled.span`
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  padding: ${() => `${viewSizeCalculator(0.75)} 0`};
  display: flex;
  gap: ${() => `${viewSizeCalculator(0.125)}`};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ViewAlllContent = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.625)}`};
  font-weight: 700;
  line-height: ${() => `${viewSizeCalculator(0.7562)}`};
  opacity: 30%;
`;

export const PlayButtonWrapper = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: ${() => `${viewSizeCalculator(-0.3125)}`};
    width: ${() => `${viewSizeCalculator(0.625)}`};
    height: ${() => `${viewSizeCalculator(0.625)}`};
  }
`;
